import styled from "styled-components";
import { COLORS } from "../../constants/Styles";

export const OptionContainer = styled.div<{ selected?: boolean }>`
  padding: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: ${({ selected }) =>
    selected ? COLORS.secondaryLight : "initial"};

  &:hover {
    background-color: ${COLORS.badgeGray};
    color: ${COLORS.secondaryLight};
  }
`;

export const OptionTitle = styled.div<{ selected?: boolean }>`
  color: ${COLORS.secondary};
  word-break: break-word;
`;

export const OptionLine = styled.div<{ selected?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${({ selected }) => (selected ? "initial" : COLORS.secondaryLight)};
`;
